module.exports = __webpack_public_path__ + "static/media/icon4.6eed89c0.png";